export const formatAge = (value) => {
  return value < 0 || value == "" || value==undefined ? '---' : value+'岁';
}
export const formatWeight = (value)=> {
  return value == null ? '---' : value + 'kg';
}
export const formatHeight= (value)=> {
  return value == null ? '---' : value + 'cm';
}
export const formatVal=(value)=> {
  return value == null ? '---' : value;
}
export const formatDate=(value)=>{
  return value && value.length > 10 ? value.substring(0, 10) : value;
}
export const formatFixed2=(value)=>{
  if (value == '0') value = '0.00'
  value = (value == null || value == 'null' || value == '') ? '---' : (value > 0 ? '+' + parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2));
  return value;
}

export const formatGy=(value)=> {
  let arr = ['正常', '缺失1/3', '1/3<缺失<2/3', '缺失>2/3'];
  value = value == null ? '---' : arr[value];
  return value;
}